import { useCallback } from "react";

import CloseIcon from "@/components/ui/icon/cross";

import type * as Model from "../../model";

type Props = {
	selectedTagList: Model.Type.ViewModel["selectedTagList"];
	onSelectCallback: (tag: string) => void;
};

export const SelectedTagLabelList = ({ selectedTagList, onSelectCallback }: Props) => {
	/**
	 * タグ押下時の処理
	 */
	const handleClickTag = useCallback(
		(value: string) => {
			onSelectCallback(value);
		},
		[onSelectCallback],
	);

	return (
		<>
			{selectedTagList.map((tag, index) => {
				const tagText = `# ${tag}`;
				return (
					<label
						key={index}
						className="flex max-w-[max-content] cursor-pointer items-center gap-2 rounded border border-zinc-100 text-sm duration-1000 hover:shadow-xl"
						onClick={() => handleClickTag(tag)}
					>
						<span className="p-2">{tagText}</span>

						<span className="grid h-full place-content-center rounded-r bg-black p-1 text-center">
							<CloseIcon className="h-3 w-3   text-bg-layer-50" />
						</span>
					</label>
				);
			})}
		</>
	);
};
